// Import and re-export content script types
import type { AutomationTask } from "./contentScript/types";
export * from "./contentScript/types";

export enum EncampyCommand {
  RUN_AUTOMATION_FLOW = "RUN_AUTOMATION_FLOW",
}

export enum PortalType {
  TIER_2_MANAGER = "Tier2Manager",
  EPLAN = "EPlan",
}

export enum ConnectionState {
  DISCONNECTED = "DISCONNECTED",
  CONNECTING = "CONNECTING",
  CONNECTED = "CONNECTED",
  ERROR = "ERROR",
}

export type EncampyBaseRequest = {
  command: EncampyCommand;
  requestId?: string;
};

export type EncampyRequest = EncampyRunAutomationFlowRequest;

export type EncampyRunAutomationFlowRequest = EncampyBaseRequest & {
  command: EncampyCommand.RUN_AUTOMATION_FLOW;
  payload: EncampyRunAutomationFlowPayload;
};

export type EncampyRunAutomationFlowPayload = {
  tasks: AutomationTask[];
  tabId?: number;
  url?: string;
};

export type EncampyBaseResponse = {
  success: boolean;
  requestId?: string;
};

export type EncampyResponse = EncampySuccessResponse | EncampyErrorResponse;

export type EncampySuccessResponse = EncampyBaseResponse & {
  success: true;
  data?: any;
};

export type EncampyErrorResponse = EncampyBaseResponse & {
  success: false;
  error: string;
  details?: any;
};

export interface EncampyPort extends chrome.runtime.Port {
  postMessage(message: EncampyResponse): void;
  onMessage: chrome.events.Event<(message: EncampyRequest) => void>;
}
